
function PreviewIntership() {
  return (
    <h3>Preview Intership</h3>
  );
}

export default PreviewIntership;